import { Language } from '../enums';
export const LOCALE = new Map([
    [Language.ENGLISH, Language.ENGLISH_US],
    [Language.ENGLISH_US, Language.ENGLISH_US],
    [Language.SPANISH, Language.SPANISH_SPAIN],
    [Language.SPANISH_SPAIN, Language.SPANISH_SPAIN],
    [Language.FRENCH, Language.FRENCH_FRANCE],
    [Language.FRENCH_FRANCE, Language.FRENCH_FRANCE],
    [Language.FRENCH_CANADA, Language.FRENCH_CANADA]
]);
//# sourceMappingURL=LocaleConstants.js.map